type namePart = string | null;

const getFullName = (names: namePart[]) => names.filter(name => name).join(" ");

export default getFullName;
